/**
 * Formats a number as a currency string with 2 decimal places (e.g. "3.00").
 *
 * Uses locale-aware formatting for proper thousand separators.
 * Different from charting formatCurrency which uses B/M/K suffixes.
 *
 * @param value - The numeric value to format
 * @returns Formatted string like "3.00" or "1,500.00"
 */
export function formatOfferCurrency(value: number): string {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

/**
 * Generates pill text describing min/max case constraints for a product tier.
 *
 * @param min - Minimum cases required (0 means no minimum)
 * @param max - Maximum cases allowed (null/undefined means uncapped)
 * @returns Display text like "No maximum", "Max 5 cases", or "Min 1 / Max 5 cases"
 */
export function getPillText(
  min: number,
  max: number | null | undefined
): string {
  const isUncapped = max === null || max === undefined
  if (isUncapped)
    return min > 0
      ? `Min ${min.toLocaleString()} cases / No maximum`
      : 'No maximum'
  return min > 0
    ? `Min ${min.toLocaleString()} / Max ${max.toLocaleString()} cases`
    : `Max ${max.toLocaleString()} cases`
}
